import { includes, isNil } from "lodash";
import { isAlpha, isMobilePhone } from "validator";
import { mailList } from "./publicMailDomains";
import { USERNAME_CRITERIA } from "./constants";

export const BILLING_PHONE_CRITERIA = "Not a valid phone number.";

const phoneNumberPattern = /^(\+\d{1,3}[- ]?)?\d{4,14}$/;
const namePattern = /^[a-zA-Z ]*$/;
const domainPattern =
  /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
const streetCityPattern = /[<>/%*//]/;
const usernamePattern = /^[a-z0-9_-]+(?:\.[a-z0-9_-]+)*$/;

export const emailValidator = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(value)
    ? "Invalid email address"
    : undefined;
export const notNil = (value) => (isNil(value) ? "Required" : undefined);
export const required = (value) =>
  value || typeof value === "number" ? undefined : "Required";

export const max60 = (value) =>
  value && value.length <= 60 ? undefined : "Input is too long.";

export const max10 = (value) =>
  value && value.length <= 10 ? undefined : "Input is too long.";

export const max16 = (value) =>
  value && value.length <= 16 ? undefined : "Input is too long.";
export const max50 = (value) =>
  value && value.length <= 50 ? undefined : "Input is too long.";

export const alphabetOnly = (value) =>
  value && isAlpha(value.replace(/\s/g, ""))
    ? undefined
    : "Name must only contain alphabets";
/**
 * Checks if valid phone number for billing details update
 * @param {*} value
 */
export const billingPhone = (value) => {
  return phoneNumberPattern.test(value) ? false : BILLING_PHONE_CRITERIA;
};
export const isDomainValidate = (value) => {
  return value && domainPattern.test(value) ? false : "Not a valid domain";
};

export const notPublicDomain = (value) => {
  return value && includes(mailList, value)
    ? "Please use your business domain"
    : undefined;
};

export const mailNotPublicDomain = (value) => {
  const domain = value.split("@")[1];
  return value && includes(mailList, domain)
    ? "Please use your business domain."
    : undefined;
};
export const postalCode = (value) => undefined;
export const phoneValid = (value) => {
  return value && isMobilePhone(value) ? undefined : "Not a valid phone number";
};
export const internationalPhonevalid = (value) => {
  return value && /^\+(?:[0-9] ?){6,14}[0-9]$/.test(value)
    ? undefined
    : "Not a valid phone number";
};

/**
 * Check the conditions for name.
 * allows : only alphabets and spaces
 * @param {*} value
 * @returns {*} HTML or false
 */
export const validName = (value) => {
  if (isAlpha(value.replace(/\s/g, ""))) {
    if (namePattern.test(value)) {
      return false;
    } else {
      return "Field is invalid";
    }
  } else {
    return "Name must only contain alphabets";
  }
};
/**
 * Check phone number is beyond length
 * @param {*} value
 * @returns HTML or false
 */
export const max15 = (value) =>
  value && value.length <= 15 ? undefined : "Phone number is too long.";

/**
 * Check street city contains <>/%*
 * @param {*} value
 * @returns HTML or false
 */
export const streetCityValidation = (val) => {
  return streetCityPattern.test(val) ? "<>/%*  are not allowed" : false;
};

/**
 * Check the conditions for username.
 * @param {*} value
 * @returns {*} HTML or false
 */
export const validUsername = (value) => {
  return value && usernamePattern.test(value) ? undefined : USERNAME_CRITERIA;
};
